import React, { useEffect } from 'react'
import sharedClasses from './signup.module.css'
import classes from './SignIn.module.css'
import classNames from 'classnames'
import loginImage from '../../assets/images/Login.jpg'
import logo from '../../assets/images/new-logo.png'
import { ReactComponent as ArrowRight } from '../../assets/icons/arrow-right.svg'
import { ReactComponent as LeftIcon } from '../../assets/icons/left.svg'
import { ValidatedLoginInput } from '../../components/Form/Inputs/Inputs'
import { Button, ButtonIcon } from '../../components/Button/Button'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { getParentRoute } from '../../util/functions'
import useAuthForm from '../../hooks/useAuthForm'
import { login } from '../../api/authApi'
import { LoginSchema } from '../../util/formSchemas'
import { Formik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import { UserTypes } from '../../util/constants'
import { startWizard } from '../Wizard/wizardLogic'
import { userActions, userSelectors } from '../../redux/userSlice'

const SignIn = ({ location }) => {
    const { goBack, push } = useHistory()
    const { search } = useLocation()
    const query = new URLSearchParams(search.substr(1))
    const fromCourse = query.has('fromCourse')

    const path = getParentRoute(location.pathname)

    const dispatch = useDispatch()

    const redirectUrl = useSelector(userSelectors.redirectUrl)

    useAuthForm(async (hasPlan, userType) => {
        if (userType === UserTypes.Beneficiary) {
            push('/app/beneficiary/my-courses')
        } else {
            if (hasPlan) {
                if (redirectUrl) {
                    dispatch(userActions.resetRedirectUrl())
                    push(redirectUrl)
                } else {
                    push('/app/dashboard')
                }
            } else {
                push(startWizard())
            }
        }
    }, true)

    // if (hasPlan) {
    //     if (redirectUrl) {
    //         dispatch(userActions.resetRedirectUrl())
    //         history.push(redirectUrl)
    //     } else {
    //         history.push('/app/dashboard')
    //     }
    // } else {
    //     history.push(startWizard())
    // }

    const submitForm = values => {
        dispatch(login(values))
    }

    return (
        <div className={classNames(sharedClasses.container, classes.container)}>
            {fromCourse && (
                <div className={classes.backContainer}>
                    <button
                        type="button"
                        onClick={goBack}
                        className={classes.backButton}
                    >
                        <LeftIcon />
                        Back
                    </button>
                </div>
            )}
            <Formik
                initialValues={{
                    email: '',
                    password: '',
                }}
                onSubmit={submitForm}
                validationSchema={LoginSchema}
            >
                {({ handleSubmit }) => (
                    <div
                        className={classNames(sharedClasses.form, classes.form)}
                    >
                        <img
                            src={logo}
                            alt="SME Upturn"
                            className={sharedClasses.formLogo}
                            onClick={() => push('/')}
                        />
                        <h1 className={sharedClasses.formHeader}>
                            Welcome Back
                        </h1>
                        <div className={sharedClasses.formInputs}>
                            <ValidatedLoginInput
                                className={classes.input}
                                placeholder={'Email Address'}
                                name={'email'}
                            />
                            <ValidatedLoginInput
                                className={classes.input}
                                placeholder={'Password'}
                                name={'password'}
                                type={'password'}
                            />
                        </div>
                        <Button
                            className={sharedClasses.formButton}
                            onClick={handleSubmit}
                        >
                            Get Started
                            <ButtonIcon icon={<ArrowRight />} />
                        </Button>
                        <span
                            className={classNames(
                                sharedClasses.formSplitLine,
                                classes.formSplitLine
                            )}
                        />
                        <p className={sharedClasses.formSignInText}>
                            Forgot Your Password?{' '}
                            <Link
                                to={`${path}/forgot-password`}
                                className={sharedClasses.formSignInTextOrange}
                            >
                                Reset it here
                            </Link>
                        </p>
                        <p className={sharedClasses.formSignInText}>
                            Don't have a regular account?{' '}
                            <Link
                                to={`${path}/sign-up`}
                                className={sharedClasses.formSignInTextOrange}
                            >
                                Sign up here
                            </Link>{' '}
                        </p>
                        <p className={sharedClasses.formSignInText}>
                            Don't have a business account?{' '}
                            <Link
                                to={`/app/business/sign-up`}
                                className={sharedClasses.formSignInTextOrange}
                            >
                                Sign up here
                            </Link>
                        </p>
                    </div>
                )}
            </Formik>
            <img
                src={loginImage}
                alt="Sign In"
                className={sharedClasses.displayImage}
            />
        </div>
    )
}

export default SignIn
